// src/pages/SuperAdminDashboardPage.jsx
import React from 'react';
import Layout from '../../components/Layout';
import StoreMaintenance from '../../components/StoreMaintenance';

const StoreMaintenancePage = () => {
  const role = 'admin';
  return (
    <Layout role={role}>
      <StoreMaintenance/>
    </Layout>
  );
};

export default StoreMaintenancePage;
